import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tableService } from '../../services/tableService';
import TableCreateForm from './TableCreateForm';
import './Tables.css';

const TablesPage = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadTables();
  }, []);

  const loadTables = async () => {
    setLoading(true);
    const result = await tableService.listTables();

    if (result.success) {
      setTables(result.tables);
    } else {
      showNotification(result.error, 'error');
    }

    setLoading(false);
  };

  const showNotification = (message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
  };

  const handleDeleteTable = async (tableName) => {
    if (window.confirm(`Delete table "${tableName}"? This will remove all data.`)) {
      const result = await tableService.deleteTable(tableName);
      if (result.success) {
        showNotification(result.message || 'Table deleted', 'success');
        loadTables();
      } else {
        showNotification(result.error, 'error');
      }
    }
  };

  return (
    <div className="tables-page">
      <header className="tables-header">
        <div className="header-content">
          <div>
            <h1>Tables Management</h1>
            <p>Build schemas, manage tables, and assign permissions.</p>
          </div>
          <div className="tables-header-actions">
            <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
              Back to Dashboard
            </button>
            <button className="btn btn-primary" onClick={() => setShowCreateForm(true)}>
              Create Table
            </button>
          </div>
        </div>
      </header>

      <main className="tables-main">
        {notification.show && (
          <div className={`notification ${notification.type}`}>
            {notification.message}
          </div>
        )}

        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading tables...</p>
          </div>
        ) : (
          <div className="tables-grid">
            {tables.map((table) => (
              <div key={table.id} className="table-card">
                <div className="table-card-header">
                  <div>
                    <h3>{table.table_name}</h3>
                    <p>{table.description || 'No description yet'}</p>
                  </div>
                  <span className="table-badge">{table.column_count} columns</span>
                </div>
                <div className="table-card-meta">
                  <span>Created: {new Date(table.created_at).toLocaleDateString()}</span>
                </div>
                <div className="table-card-actions">
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(`/dashboard/tables/${table.table_name}`)}
                  >
                    View Details
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDeleteTable(table.table_name)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}

            {tables.length === 0 && (
              <div className="empty-state">
                <p>No tables yet. Create your first table to get started.</p>
              </div>
            )}
          </div>
        )}
      </main>

      {showCreateForm && (
        <TableCreateForm
          isOpen={showCreateForm}
          onClose={() => setShowCreateForm(false)}
          onTableCreated={() => {
            setShowCreateForm(false);
            loadTables();
            showNotification('Table created successfully', 'success');
          }}
        />
      )}
    </div>
  );
};

export default TablesPage;
